import * as React from "react"
import { PropsWithChildren } from "react"
import ISearchInput from "./types"
import { Input, SearchInputWrapper, SearchButton } from "./styles"
import {} from "../../Global"
import { Icon } from "@iconify/react"
import search32Regular from "@iconify-icons/fluent/search-32-regular"

const SearchInput = ({ margin }: PropsWithChildren<ISearchInput>) => {
  return (
    <SearchInputWrapper margin={margin && margin}>
      <Input placeholder="Szukaj..." />
      <SearchButton>
        <Icon icon={search32Regular} />
      </SearchButton>
    </SearchInputWrapper>
  )
}

export default SearchInput
